export default __webpack_public_path__ + "static/media/man.6ef1ed05.jpeg";